import React from 'react';
import PropTypes from 'prop-types';

const MealOrderingLink = ({ stationName }) => {
  const handleOrderMealsClick = () => {
    window.location.href = 'https://www.makemytrip.com/railways/food';
  };

  return (
    <div style={{ cursor: 'pointer' }} onClick={handleOrderMealsClick}>
      <img
        src="https://go-assets.ibcdn.com/u/MMT/images/1748794706992-mealsBox.webp"
        alt="Order Meal"
        style={{
          width: '16px',
          height: '16px',
          marginRight: '6px',
          verticalAlign: 'middle'
        }}
      />
      <span
        style={{
          color: '#8B4513',
          fontSize: '12px',
          fontWeight: '800',
          verticalAlign: 'middle'
        }}
      >
        Order Meal
      </span>
    </div>
  );
};

MealOrderingLink.propTypes = {
  stationName: PropTypes.string
};

export default MealOrderingLink;
